import script from "./list-service-group.vue?vue&type=script&setup=true&lang=js"
export * from "./list-service-group.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__